import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { calendarIcon, shieldIcon, targetIcon } from 'src/app/app-icons';
import { PublishingMode } from 'src/app/models/training/publishing-mode.model';

@Component({
  selector: 'app-publication-mode-selection',
  standalone: false,
  templateUrl: './publication-mode-selection.component.html',
  styleUrl: './publication-mode-selection.component.scss',
})
export class PublicationModeSelectionComponent {
  @Input()
  mode: PublishingMode | null = PublishingMode.ByInvitationOnly;

  @Input()
  isPublishedToSubscribers: boolean = false;

  @Input()
  isPrivatePublishing: boolean = false;

  @Input()
  isViewMode: boolean = false;

  @Input() 
  isCourse = false;

  @Output()
  modeChange = new EventEmitter<PublishingMode>();

  modes: any[] = [];

  constructor(
    private sanitized: DomSanitizer,
    private translateService: TranslateService,
  ) {
  }

  ngOnChanges(): void {
    const type = this.isCourse ? 'ELEARNING' : 'TRAINING';

    this.modes = [
      {
        value: PublishingMode.ByInvitationOnly,
        title: this.translateService.instant(
          'PUBLISHING-MODES.INVITATION-ONLY.TITLE'
        ),
        description: this.translateService.instant(
          'PUBLISHING-MODES.INVITATION-ONLY.DESCRIPTION'
        ),
        icon: this.getShieldIcon()
      }
    ];

    if (this.isPrivatePublishing || !this.isPublishedToSubscribers) {
      this.modes.push(
        {
          value: PublishingMode.DeployToTargetGroup,
          title: this.translateService.instant(
            `PUBLISHING-MODES.TARGET-GROUP.${type}.TITLE`
          ),
          description: this.translateService.instant(
            `PUBLISHING-MODES.TARGET-GROUP.${type}.DESCRIPTION`
          ),
          icon: this.getTargetIcon()
        },
        {
          value: PublishingMode.PublishToCatalogue,
          title: this.translateService.instant(
            `PUBLISHING-MODES.PUBLISH-TO-CATALOGUE.${type}.TITLE`
          ),
          description: this.translateService.instant(
            `PUBLISHING-MODES.PUBLISH-TO-CATALOGUE.${type}.DESCRIPTION`
          ),
          required: true,
          icon: this.getCalendarIcon()
        }
      );
    } else {
      this.modes.push({
        value: PublishingMode.PublishToSubscribers,
        title: this.translateService.instant(
          'PUBLISHING-MODES.PUBLISH-TO-SUBSCRIBERS.TITLE'
        ),
        description: this.translateService.instant(
          'PUBLISHING-MODES.PUBLISH-TO-SUBSCRIBERS.DESCRIPTION'
        ),
        required: true,
        icon: this.getCalendarIcon()
      });
    }
  }

  getTargetIcon() {
    return this.sanitized.bypassSecurityTrustHtml(targetIcon);
  }

  getShieldIcon() {
    return this.sanitized.bypassSecurityTrustHtml(shieldIcon);
  }

  getCalendarIcon() {
    return this.sanitized.bypassSecurityTrustHtml(calendarIcon);
  }

  onModeChanged(e: any): void {
    this.mode = e.value;
    this.modeChange.emit(e.value);
  }
}
